import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useContext, useState } from 'react';
import { Mail } from "lucide-react";
import axios from 'axios';

import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Eye, EyeOff, GraduationCap, Lock, Phone } from 'lucide-react';
import { UserContext } from '@/lib/User';
import { set } from 'lodash';

const Login = () => {
    const {user,setUser} = useContext(UserContext);
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            const formData = new FormData();
            formData.append('phone_number', phone);
            formData.append('password', password);

            const response = await axios.post('https://xceededge.com/login.php', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            if (response.data.status === 'success') {
                // Store token if provided
                if (response.data.session) {
                    setUser({session: response.data.session});
                }
              navigate('/');
            } else {
                setError(response.data.message || 'Login failed');
            }
        } catch (err) {
            setError(err.response?.data?.message || 'An error occurred during login');
            console.error('Login error:', err);
        } finally {
            setLoading(false);
        }
    };
    return(
        <>
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="min-h-screen flex items-center justify-center px-4 pt-20 pb-10">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
      <Link to="/" className="inline-flex items-center mb-6">
  <img 
    src="https://www.xceededge.in/XceedTransLogo.png" 
    alt="XceedEdge Logo" 
    className="h-20 w-auto object-contain"
  />
</Link>
          <h1 className="font-heading text-2xl font-bold">
            {'Welcome Back'}
           
          </h1>
          <p className="text-muted-foreground text-sm mt-1">
            {'Sign in to continue learning'}
            
          </p>
        </div>
        <div className="bg-card rounded-2xl border shadow-lg p-6 sm:p-8">
                <form className="space-y-6" onSubmit={handleSubmit}>
                            <div className='space-y-4'>
                                {error && (
                                    <div className="bg-red-50 text-red-800 text-sm p-3 rounded-lg border border-red-200">
                                        {error}
                                    </div>
                                )}

                                 <div>
                 <Label>Email Address</Label>
<div className="relative mt-1">
  <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
  <Input
    type="email"
    value={email}
    onChange={e => setEmail(e.target.value)}
    className="pl-10"
    placeholder="Enter Your Registered Email"
    required
  />
</div>
                </div>
                                 <div>
                  <Label>Password</Label>
                  <div className="relative mt-1">
                    <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
                    <Input
                      type={showPassword ? 'text' : 'password'}
                      value={password}
                      onChange={e => setPassword(e.target.value)}
                      className="pl-10 pr-10"
                      placeholder="••••••••"
                      required
                    />
                    <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground">
                      {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                    </button>
                  </div>
                </div>
                <div className="flex justify-end">
                    <button type="button"  className="text-xs text-primary hover:underline"><Link to={"/forgot-password"}>Forgot password?</Link></button>
                  </div>
                            </div>
                            <Button type="submit" className="w-full h-11 text-base font-semibold" disabled={loading}>
                                {loading ? 'Signing in...' : 'Login'}
                            </Button>
                            <button type="button"  className="text-sm text-primary hover:underline w-full text-center block mt-2">  
                            <Link to={'/auth'}>
                            Don't have an account? Sign up</Link>
                            </button>
                        </form>
                        {/* <div className="relative my-6">
                                        <div className="absolute inset-0 flex items-center"><div className="w-full border-t" /></div>
                                        <div className="relative flex justify-center"><span className="bg-card px-3 text-xs text-muted-foreground">or continue with</span></div>
                                      </div>
                        
                                      <Button variant="outline" className="w-full gap-2" >
                                        <svg className="w-4 h-4" viewBox="0 0 24 24"><path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4"/><path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/><path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/><path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/></svg>
                                        Google
                                      </Button> */}
        </div>
        </div>
    </motion.div>
        </>
    )
}
export default Login;